import moment from 'moment';

export const dateCookieName = 'ArshtCalendarDate';

//Set the value of a cookie, optionally pass the cookie duration in minutes
export function setCookie(name: string, value: string, minutes: number = undefined): void {
    var expires = "";
    if (minutes) {
        var expiration = moment().add(minutes, 'm').utc().format();
        expires = "; expires=" + expiration;
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

//Get the value of a cookie, returns null if the cookie is not found
export function getCookie(name: string): string {
    var nameSubstring = name + "=";
    var allCookies = document.cookie.split(';');
    for (var i = 0; i < allCookies.length; i++) {
        var c = allCookies[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameSubstring) == 0) return c.substring(nameSubstring.length, c.length);
    }
    return null;
}